export function canManageReservations(admin) {
  return ['admin', 'hotel'].includes(admin?.adminRole) && admin.isActive !== false;
}
